import { MeditatorTabs, TableTitles } from "@/constants";
import { Button, Divider, TableProps } from "antd";
import { Link } from "react-router";
import { BackIcon } from "../common/icons";
import { MeditationRetreatsTable } from "../MeditationRetreats";

export function RegistrantDetailHeader({
    redirectTab,
    retreatData,
    loading = false
}: {
    redirectTab: keyof typeof MeditatorTabs,
    retreatData: TableProps<MeditationRetreat>["dataSource"],
    loading?: boolean
}) {

    const retreatRenderColumnsKey = [
        TableTitles.retreat_start_month,
        TableTitles.retreat_level,
        TableTitles.retreat_name,
        TableTitles.retreat_duration,
        TableTitles.retreat_start_date,
        TableTitles.retreat_end_date,
        TableTitles.total_registrants
    ]

    return (
        <div>
            <div
                className="flex items-center gap-2"
            >
                <Link
                    to={`/retreat-registrants?tab=${redirectTab}`}
                >
                    <Button
                        type="text"
                        icon={
                            <BackIcon />
                        }
                    />
                </Link>
                <h2
                    className="text-base font-semibold -mt-1.5"
                >
                    တရားစခန်း အချက်အလက်
                </h2>
            </div>
            <Divider />
            <MeditationRetreatsTable
                renderColumnKeys={retreatRenderColumnsKey}
                dataSource={retreatData}
                hasFilter={false}
                loading={loading}
                pagination={false}
            />
        </div>
    )
}
